module.exports = __webpack_public_path__ + "static/media/number4.9f98fece.svg";